export const GET_CLIENT_BASIC_DETAILS = "GET_CLIENT_BASIC_DETAILS";
export const SET_CLIENT_BASIC_DETAILS_SUCCESS = "SET_CLIENT_BASIC_DETAILS_SUCCESS";
export const SET_CLIENT_BASIC_DETAILS_FAILED = "SET_CLIENT_BASIC_DETAILS_FAILED";

export const GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS = "GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS";
export const SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_SUCCESS = "SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_SUCCESS";
export const SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_FAILED = "SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_FAILED";

export const GET_CLIENT_MEDICAL_HISTORY_DETAILS = "GET_CLIENT_MEDICAL_HISTORY_DETAILS";
export const SET_CLIENT_MEDICAL_HISTORY_DETAILS_SUCCESS = "SET_CLIENT_MEDICAL_HISTORY_DETAILS_SUCCESS";
export const SET_CLIENT_MEDICAL_HISTORY_DETAILS_FAILED = "SET_CLIENT_MEDICAL_HISTORY_DETAILS_FAILED";

export const GET_CLIENT_CASE_DETAILS = "GET_CLIENT_CASE_DETAILS";
export const SET_CLIENT_CASE_DETAILS = "SET_CLIENT_CASE_DETAILS";

export const GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION = "GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION";
export const SET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION = "SET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION";
export const GET_CLIENT_INJURY_DETAILS = "GET_CLIENT_INJURY_DETAILS";
export const SET_CLIENT_INJURY_DETAILS = "SET_CLIENT_INJURY_DETAILS";


export const GET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION = "GET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION";
export const SET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION = "SET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION";

export const GET_CLIENT_SIGNATURE_DETAILS = "GET_CLIENT_SIGNATURE_DETAILS";
export const SET_CLIENT_SIGNATURE_DETAILS = "SET_CLIENT_SIGNATURE_DETAILS";

export const GET_SERVICE_LIST = "GET_SERVICE_LIST";
export const SET_SERVICE_LIST = "SET_SERVICE_LIST";


export const getClientAuthorizationDiscloseProtectedHealthInformation = (initialAppointmentId: any) => {
    return {
        type: GET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION,
        payload: {
            initialAppointmentId
        }
    }
}

export const setClientAuthorizationDiscloseProtectedHealthInformation = (authorizationDiscloseProtectedHealthInformation: any) => {
    return {
        type: SET_AUTHORIZATION_DISCLOSE_PROTECTED_HEALTH_INFORMATION,
        payload: {
            authorizationDiscloseProtectedHealthInformation
        }
    }
}

export const getClientBasicDetails = () => {
    return {
        type: GET_CLIENT_BASIC_DETAILS
    }
};

export const setClientBasicDetailsSuccess = (clientBasicDetails: any) => {
    return {
        type: SET_CLIENT_BASIC_DETAILS_SUCCESS,
        payload: clientBasicDetails
    }
};

export const setClientBasicDetailsFailed = (error: any) => {
    return {
        type: SET_CLIENT_BASIC_DETAILS_SUCCESS,
        payload: error
    }
};

export const getClientCommunicationReferralDetails = () => {
    return {
        type: GET_CLIENT_COMMUNICATION_REFERRAL_DETAILS
    }
};

export const setClientCommunicationReferralDetailsSuccess = (clientCommunicationReferralDetails: any) => {
    return {
        type: SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_SUCCESS,
        payload: clientCommunicationReferralDetails
    }
};

export const setClientCommunicationReferralDetailsFailed = (error: any) => {
    return {
        type: SET_CLIENT_COMMUNICATION_REFERRAL_DETAILS_FAILED,
        payload: error
    }
};

export const getClientMedicalHistoryDetails = () => {
    return {
        type: GET_CLIENT_MEDICAL_HISTORY_DETAILS
    }
};

export const setClientMedicalHistoryDetailsSuccess = (clientMedicalHistoryDetails: any) => {
    return {
        type: SET_CLIENT_MEDICAL_HISTORY_DETAILS_SUCCESS,
        payload: clientMedicalHistoryDetails
    }
};

export const setClientMedicalHistoryDetailsFailed = (error: any) => {
    return {
        type: SET_CLIENT_MEDICAL_HISTORY_DETAILS_FAILED,
        payload: error
    }
};

export const getClientCaseDetails = (caseId: any) => {
    return {
        type: GET_CLIENT_CASE_DETAILS,
        payload: {
            caseId
        }
    }
};

export const setClientCaseDetails = (clientCaseDetails: any) => {
    return {
        type: SET_CLIENT_CASE_DETAILS,
        payload: {
            clientCaseDetails
        }
    }
}

export const getClientAuthorizationToReleaseInformation = () => {
    return {
        type: GET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION,
    }
}

export const setClientAuthorizationToReleaseInformation = (clientAuthorizationToReleaseInformation: any) => {
    return {
        type: SET_CLIENT_AUTHORIZATION_TO_RELEASE_INFORMATION,
        payload: {
            clientAuthorizationToReleaseInformation
        }
    }
}

export const getClientInjuryDetails = () => {
    return {
        type: GET_CLIENT_INJURY_DETAILS,

    }
}

export const setClientInjuryDetails = (clientInjuryDetails: any) => {
    return {
        type: SET_CLIENT_INJURY_DETAILS,
        payload: {
            clientInjuryDetails
        }
    }
}

export const getClientSignatureDetails = (isOnboarded: boolean, initialAppointmentId?: string) => {
    return {
        type: GET_CLIENT_SIGNATURE_DETAILS,
        payload: {
            isOnboarded,
            initialAppointmentId
        }
    }
}

export const setClientSignatureDetails = (clientSignatureDetails: any) => {
    return {
        type: SET_CLIENT_SIGNATURE_DETAILS,
        payload: {
            clientSignatureDetails
        }
    }
}

export const getServicesList = () => {
    return {
        type: GET_SERVICE_LIST
    }
}
export const setServicesList = (serviceList: any) => {
    return {
        type: SET_SERVICE_LIST,
        payload: {
            serviceList
        }
    }
}

